import L from 'leaflet';
import { AvatarConfig } from '../../types/user';

const cache = new Map<string, L.DivIcon>();

export function createAvatarIcon(avatar: AvatarConfig, isMoving: boolean, isMe: boolean): L.DivIcon {
  const cacheKey = `${avatar.bgColor}_${avatar.emoji}_${avatar.shape}_${avatar.borderColor}_${avatar.profilePhoto || ''}_${isMoving}_${isMe}`;
  const cached = cache.get(cacheKey);
  if (cached) return cached;

  const size = isMe ? 44 : 38;
  const pulse = isMoving
    ? `<span style="position:absolute;inset:-6px;border-radius:50%;border:2px solid #facc15;animation:stabeon-pulse 1.4s ease-out infinite;opacity:.7"></span>`
    : '';
  const ring = isMe
    ? `border:3px solid #7c3aed;box-shadow:0 0 0 3px #7c3aed44`
    : `border:2px solid ${avatar.borderColor}`;

  const shapeRadius = avatar.shape === 'circle' ? '50%'
    : avatar.shape === 'rounded' ? '30%'
    : '30% 0';

  const hasPhoto = avatar.profilePhoto && avatar.profilePhoto.length > 20;

  const content = hasPhoto
    ? `<img src="${avatar.profilePhoto}" style="width:100%;height:100%;object-fit:cover;border-radius:${shapeRadius}" />`
    : avatar.emoji;

  const bgStyle = hasPhoto ? 'background:transparent;overflow:hidden;' : `background:${avatar.bgColor};`;

  const html = `
    <div style="position:relative;width:${size}px;height:${size}px">
      ${pulse}
      <div style="
        width:${size}px;height:${size}px;
        border-radius:${shapeRadius};
        ${bgStyle}
        ${ring};
        display:flex;align-items:center;justify-content:center;
        font-size:${size * 0.48}px;
        box-sizing:border-box;
        cursor:pointer;
        transition:transform .15s;
      ">${content}</div>
    </div>`;

  const icon = L.divIcon({
    html,
    className: '',
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    popupAnchor: [0, -(size / 2 + 6)],
  });

  cache.set(cacheKey, icon);
  return icon;
}
